export const dontShowNav = [
    {url: '/', label: 'Home', key: 'home', permissions: []},
    {url: '/sign-in', label: 'Sign in', key: 'sign-in', permissions: []},
]